import { styled } from '@mui/system';
import { Box, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const DrawerContainer = styled(Box)(({ theme }) => ({
  transition: 'width 0.3s ease-in-out',
  backgroundColor: 'black',
  marginLeft: theme.spacing(2),
  borderRadius: theme.spacing(2),
  minWidth: '24em',
  display: 'flex',
  height: 'calc(100vh - 100px)', // Match the MainContentContainer height constraint
  gap: theme.spacing(2),
  flexDirection: 'column',
  '&.closed': {
    width: 0,
    display: 'none',
  },
  '&.open': {
    width: 390,
    display: 'flex',
  },
}));

export const DrawerHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
  paddingBottom: '0px',
  color: theme.palette.text.primary,
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const DrawerContent = styled(Box)(({ theme }) => ({
  padding: `0 ${theme.spacing(2)} ${theme.spacing(2)}`,
  overflow: 'auto',
  flex: '1',
  minHeight: 0, // Important: allows flex child to shrink below content size
  maxHeight: 'calc(100vh - 100px - 80px)', // Account for header height (approximately 80px)
}));

export const DrawerContentContainer = styled(Box)(({ alignment = 'center', theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: alignment,
  gap: theme.spacing(2),
  width: '100%',
  minHeight: 0, // Allows container to shrink and enable proper scrolling
}));

export const StyledArrowBackIcon = styled(ArrowBackIcon)(({ theme }) => ({
  color: theme.palette.text.main,
}));
